module.exports = __webpack_public_path__ + "static/vr-5-3-5c329b1dc74030d3e5fa7b201a36c063.jpeg";